module.exports = __webpack_public_path__ + "img/Болезни таза и тазобедренных суставов.eb07c698.jpg";